
import { Input } from "../input"
import {
    NavbarContainer,
    IconContainer,
    ActionsContainer,
    NotificationIconContainer,
    FormContainer,
    StyledSearchInputContainer,
    StyledOtherActions,
    StyledAvatarContainer,
    StyledAvatar
} from './dashboard-navbar.style'
import { MdSearch, MdMenu, MdArrowDropDown } from "react-icons/md";
import { BsBell } from "react-icons/bs";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";

//Search schema
const schema = yup.object().shape({
    text: yup.string().required("Type in something..."),
});



const DashboardNavbar = ({ toggle }) => {
    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <NavbarContainer>
            <IconContainer>
                <MdMenu size={30} onClick={toggle} />
            </IconContainer>
            <ActionsContainer>
                <FormContainer onSubmit={handleSubmit(onSubmit)}>
                    <StyledSearchInputContainer>
                        <Input
                            // endAdornment={}
                            placeholder='Search'
                            className="search"
                            {...register("text")}
                            error={errors.text?.message}
                        />
                        <div role="button" className="search-btn-icon">
                            <MdSearch size={14} />
                        </div>
                    </StyledSearchInputContainer>

                </FormContainer>
                <StyledOtherActions>
                    <span className="docs-text">docs</span>
                    <NotificationIconContainer>
                        <BsBell size={25} />
                    </NotificationIconContainer>
                    <StyledAvatarContainer>
                        <StyledAvatar />
                        <span className="avatar-name">Adedeji</span>
                        <MdArrowDropDown size={30} />
                    </StyledAvatarContainer>
                </StyledOtherActions>
            </ActionsContainer>
        </NavbarContainer>
    )
}

export { DashboardNavbar }
